import { html } from 'lit';
import componentStyles from './accordion.css.lit.ts';
import { OutlineElement } from '../../base/outline-element/outline-element.ts';

export default class Accordion extends OutlineElement {
  static styles = [super.styles, componentStyles];

  static get properties() {
    return {
      itemList: { type: Object },
    };
  }

  toggleResponse(event) {
    const accordions = this.shadowRoot.querySelectorAll('.accordion__item');
    const { target } = event;

    Array.prototype.forEach.call(accordions, accordion => {
      if (target.id !== accordion.id) {
        this.shadowRoot.getElementById(accordion.id).setState(false);
      }
    });
  }

  render() {
    return html`
      <hf-spacing-container>
        <hf-heading level="2" levelStyle="heading2" class="accordion__title">
          ${this.title}
        </hf-heading>
        <ul class="accordion">
          ${this.itemList.map((item, index) => {
            return html`
              <li>
                <hf-accordion-item
                  id="accordion__item-${index}"
                  class="accordion__item"
                  @click="${this.toggleResponse}"
                  prompt=${item.prompt}
                  title=${item.prompt}
                  response=${item.response}
                ></hf-accordion-item>
              </li>
            `;
          })}
        </ul>
      </hf-spacing-container>
    `;
  }
}
customElements.define('hf-accordion', Accordion);
